import { AFTER_RATE_TAG } from '../constants';
import { useCalculatePlanPrice } from './useCalculatePlanPrice';
import { useCallbackAfterRate } from './useCallbackAfterRate';
import { usePrepackagedPlans } from './usePrepackagedPlans';

export const usePrepackageConsistency = () => {
  const {
    onChangePrepackagedPlan,
    quoteSelected,
    plansPackaged,
    isCustomPlanSelected,
  } = usePrepackagedPlans();
  const { plans } = useCalculatePlanPrice();

  useCallbackAfterRate(() => {
    if (!isCustomPlanSelected) {
      let expectedPrepackaged = plansPackaged
        .find((pp) => pp.Id === quoteSelected.selectedPlanPackaged);
      if (!expectedPrepackaged) {
        [expectedPrepackaged] = plansPackaged;
      }
      if (quoteSelected.selectedPlan !== expectedPrepackaged.PlanId
        || quoteSelected.deductibleId !== expectedPrepackaged.DeductibleId
        || quoteSelected.reimbursementId !== expectedPrepackaged.ReimbursementId
      ) {
        onChangePrepackagedPlan(expectedPrepackaged)({
          planAmount: expectedPrepackaged.maxAnnual,
          planId: expectedPrepackaged.PlanId,
          planPackagedId: expectedPrepackaged.Id,
        });
      }
    } else {
      // Reset selection to default prepackaged if plan no longer exists
      const currPlan = plans
        .find((plan) => plan.Plan === quoteSelected.selectedPlan);
      if (!currPlan) {
        const [expectedPrepackaged] = plansPackaged;
        onChangePrepackagedPlan(expectedPrepackaged)({
          planAmount: expectedPrepackaged.maxAnnual,
          planId: expectedPrepackaged.PlanId,
          planPackagedId: expectedPrepackaged.Id,
        });
      }
    }
  }, [
    AFTER_RATE_TAG.testEffectiveDate,
    AFTER_RATE_TAG.updatePet,
  ]);
};
